import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { serversAdapter } from './serversReducer';
import { ServersStateModel } from './serversStateModel';

const selectServersState = (state: RootState): ServersStateModel => state.servers;

export const selectIsLoadingServers = createSelector(
  selectServersState,
  (state) => state.loading,
);

export const selectErrorsForServers = createSelector(
  selectServersState,
  state => state.errors,
);

export const selectAllServers = createSelector(
  selectServersState,
  serversAdapter.getSelectors().selectAll,
);

export const selectSelectedSServerName = createSelector(
  selectServersState,
  state => state.selectedServerName,
);

export const selectSelectedServer = createSelector(
  [selectAllServers, selectSelectedSServerName],
  (servers, selectedServerName) => (
    servers.find(server => server.displayName === selectedServerName)
  )
);
